import React, { Component } from 'react';
import lodash from 'lodash';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Typography, SvgIcon, TextField, MenuItem } from '@material-ui/core';

import {
  UPDATE_USER_REQUESTED,
  UPDATE_USER_SUCCESSFULL,
  UPDATE_USER_ERRORED
} from '../../../redux/actions/types';
import { updateUser } from '../../../redux/actions/auth';
import { fetchSizes } from '../../../redux/actions/categories';
import { ReactComponent as TopIcon } from '../../../images/Icons/clothes-01-dresser.svg';
import { ReactComponent as BottomIcon } from '../../../images/Icons/clothes-02.svg';
import { ReactComponent as ShoesIcon } from '../../../images/Icons/tacos-03.svg';
import i18next from 'i18next';

const styles = theme => ({
  root: {
    padding: theme.spacing(3),
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexFlow: 'column'
    }
  },
  sizePickers: {
    flex: 1,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexFlow: 'column'
    }
  },
  sizePicker: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > svg': {
      width: '3rem',
      height: '3rem',
      marginRight: theme.spacing(2)
    },
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1)
    }
  },
  sizeRead: {
    fontSize: '1.2rem'
  },
  inputs: {
    '& > fieldset': {
      border: 'none',
      '&:hover': {
        border: 'none'
      },
      '&:active': {
        border: 'none'
      }
    },
    '&:hover': {
      border: 'none'
    }
  },
  select: {
    boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.3)',
    padding: theme.spacing(1, 2, 1, 2),
    fontSize: '0.9rem',
    '&:focus': {
      borderRadius: theme.shape.borderRadius
    }
  }
});

class Sizes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      sizeTop: props.user.size_top || { id: 0 },
      sizeBottom: props.user.size_bottom || { id: 0 },
      sizeShoes: props.user.size_shoes || { id: 0 },
      topSizes: props.sizes.filter(size => size.option_user_top),
      bottomSizes: props.sizes.filter(size => size.option_user_bottom),
      shoeSizes: props.sizes.filter(size => size.option_user_shoes),
      loadingTop: false,
      loadingBottom: false,
      loadingShoes: false
    };
  }

  componentDidMount() {
    if (this.props.editable) {
      this.props.fetchSizes();
    }
  }

  componentDidUpdate(prevProps) {
    if (!lodash.isEqual(prevProps.user, this.props.user)) {
      this.setState({
        sizeTop: this.props.user.size_top || { id: 0 },
        sizeBottom: this.props.user.size_bottom || { id: 0 },
        sizeShoes: this.props.user.size_shoes || { id: 0 }
      });
    }
    if (!lodash.isEqual(prevProps.sizes, this.props.sizes)) {
      this.setState({
        topSizes: this.props.sizes.filter(size => size.option_user_top),
        bottomSizes: this.props.sizes.filter(size => size.option_user_bottom),
        shoeSizes: this.props.sizes.filter(size => size.option_user_shoes)
      });
    }
    if (prevProps.userStatus !== this.props.userStatus) {
      if (
        !this.props.userChanges.includes('size_top') ||
        !this.props.userChanges.includes('size_bottom') ||
        !this.props.userChanges.includes('size_shoes')
      ) {
        return;
      }

      if (this.props.userStatus === UPDATE_USER_REQUESTED) {
        this.setState(state => ({
          ...state,
          loadingTop: this.props.userChanges.includes('size_top')
            ? true
            : state.loadingTop,
          loadingBottom: this.props.userChanges.includes('size_bottom')
            ? true
            : state.loadingBottom,
          loadingShoes: this.props.userChanges.includes('size_shoes')
            ? true
            : state.loadingShoes
        }));
      }
      if (this.props.userStatus === UPDATE_USER_SUCCESSFULL) {
        this.setState(state => ({
          ...state,
          loadingTop: this.props.userChanges.includes('size_top')
            ? false
            : state.loadingTop,
          loadingBottom: this.props.userChanges.includes('size_bottom')
            ? false
            : state.loadingBottom,
          loadingShoes: this.props.userChanges.includes('size_shoes')
            ? false
            : state.loadingShoes
        }));
      }
      if (this.props.userStatus === UPDATE_USER_ERRORED) {
        this.setState(state => ({
          ...state,
          loadingTop: this.props.userChanges.includes('size_top')
            ? false
            : state.loadingTop,
          loadingBottom: this.props.userChanges.includes('size_bottom')
            ? false
            : state.loadingBottom,
          loadingShoes: this.props.userChanges.includes('size_shoes')
            ? false
            : state.loadingShoes
        }));
      }
    }
  }

  handleSizeChange = (size, value) => {
    this.props.updateUser(size, value);
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Typography style={{ fontSize: '1.2rem', fontWeight: 600 }}>
          {i18next.t('mySizes', {
            ns: 'dresser'
          })}
        </Typography>
        <div className={classes.sizePickers}>
          {(this.props.editable || this.props.user.size_top) && (
            <div className={classes.sizePicker}>
              <SvgIcon viewBox="0 0 93.357 88.937">
                <TopIcon />
              </SvgIcon>
              {!this.props.editable && (
                <Typography className={classes.sizeRead}>
                  {this.props.user.size_top.name}
                </Typography>
              )}
              {this.props.editable && (
                <TextField
                  disabled={this.state.loadingTop}
                  value={this.state.sizeTop.id}
                  variant="outlined"
                  InputProps={{
                    classes: {
                      root: classes.inputs
                    }
                  }}
                  SelectProps={{
                    classes: {
                      root: classes.select
                    }
                  }}
                  onChange={({ target: { value } }) =>
                    this.handleSizeChange('sizeTop', value)
                  }
                  select
                >
                  <MenuItem value={0}>Selecciona</MenuItem>
                  {this.state.topSizes.map(currentSize => (
                    <MenuItem key={currentSize.id} value={currentSize.id}>
                      {currentSize.name}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            </div>
          )}
          {(this.props.editable || this.props.user.size_bottom) && (
            <div className={classes.sizePicker}>
              <SvgIcon viewBox="0 0 47.417 92.44">
                <BottomIcon />
              </SvgIcon>
              {!this.props.editable && (
                <Typography className={classes.sizeRead}>
                  {this.props.user.size_bottom.name}
                </Typography>
              )}
              {this.props.editable && (
                <TextField
                  disabled={this.state.loadingBottom}
                  value={this.state.sizeBottom.id}
                  variant="outlined"
                  InputProps={{
                    classes: {
                      root: classes.inputs
                    }
                  }}
                  SelectProps={{
                    classes: {
                      root: classes.select
                    }
                  }}
                  onChange={({ target: { value } }) =>
                    this.handleSizeChange('sizeBottom', value)
                  }
                  select
                >
                  <MenuItem value={0}>Selecciona</MenuItem>
                  {this.state.bottomSizes.map(currentSize => (
                    <MenuItem key={currentSize.id} value={currentSize.id}>
                      {currentSize.name}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            </div>
          )}
          {(this.props.editable || this.props.user.size_shoes) && (
            <div className={classes.sizePicker}>
              <SvgIcon viewBox="0 0 90.874 70.214">
                <ShoesIcon />
              </SvgIcon>
              {!this.props.editable && (
                <Typography className={classes.sizeRead}>
                  {this.props.user.size_shoes.name}
                </Typography>
              )}
              {this.props.editable && (
                <TextField
                  disabled={this.state.loadingShoes}
                  value={this.state.sizeShoes.id}
                  variant="outlined"
                  InputProps={{
                    classes: {
                      root: classes.inputs
                    }
                  }}
                  SelectProps={{
                    classes: {
                      root: classes.select
                    }
                  }}
                  onChange={({ target: { value } }) =>
                    this.handleSizeChange('sizeShoes', value)
                  }
                  select
                >
                  <MenuItem value={0}>Selecciona</MenuItem>
                  {this.state.shoeSizes.map(currentSize => (
                    <MenuItem key={currentSize.id} value={currentSize.id}>
                      {currentSize.name}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  sizes: state.categories.sizes,
  sizesStatus: state.categories.status,
  userStatus: state.auth.status,
  userChanges: state.auth.userChanges
});

const mapDispatchToProps = dispatch => ({
  updateUser: (size, value) => dispatch(updateUser({ [size]: value })),
  fetchSizes: () => dispatch(fetchSizes())
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Sizes)
);
